export default __webpack_public_path__ + "static/media/steps-cover-5-1.9daf6765.png";